import { redirect, type RouteObject } from 'react-router';
import { standaloneLayout } from '@/app/layouts';
import { ROUTES, buildPath } from '@/shared/routing';

/**
 * 약관 원문 화면 — `/agreements/:code` (이용약관·개인정보처리방침·환불정책).
 * public(비인증) — 앱 심사·비로그인 footer·동의폼 원문보기 접근. subscription 과 달리
 * build-target gate 없음 — 앱에서도 약관을 볼 수 있어야 한다.
 * bare `/agreements` 진입은 기본 약관(terms)으로 redirect.
 */
export function createAgreementRoute(): RouteObject {
  return {
    element: standaloneLayout({ width: 'sm' }), // TODO: 라우트별 width 값 지정 ('sm'|'md'|'lg'|'full')
    path: ROUTES.AGREEMENTS,
    children: [
      {
        index: true,
        loader: () => redirect(buildPath(ROUTES.AGREEMENT_DETAIL, { code: 'terms' })),
      },
      {
        path: ROUTES.AGREEMENT_DETAIL,
        lazy: { Component: () => import('@/pages/agreement').then((m) => m.AgreementPage) },
      },
    ],
  };
}
